export default userFilter => {
  const ageFilters =
    userFilter && userFilter.$and ? userFilter.$and.filter(v => v.age) : [];

  if (ageFilters.length <= 5) return false;
  return true;
};
